import DownloadIcon from '@mui/icons-material/Download';
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../../../constants/appRoutes";
import { buildLocalizeRoute } from "../../../../helpers/languageHelper";
import { Logout } from "../../../../services/authService";
import { SystemSettingsService } from "../../../../services/systemSettingsService";
import { DialogWrapper } from "../../../../shared/components/common/dialogWrapper";
import { FsButton } from "../../../../shared/components/button";
import { InvestorRegService } from "../../investor/investorRegService";
import { InvestorTermsAndCondition } from './termsCondition';
import { setURLParam } from '../../../../helpers/setParamUrlHelper';
import { trackOpenPanelView } from '../../../../helpers/openPanelHelper';
import { OpenPanelCategories, OpenPanelEvents } from '../../../../constants/openPanelEvents';
import { RegistrationURLSteps } from '../../../../constants/registrationURLStep';
import { LocalStorageKey } from '../../../../constants/localStorageKeys';

export const UserTermsConditionDialog = ({ state = '', onClose = () => { }, userType = 'investor' }) => {
  const systemSettingsService = new SystemSettingsService();
  const investorRegService = new InvestorRegService();
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const navigate = useNavigate();

  const settings = () => {
    return systemSettingsService.systemSettings();
  };

  const { t } = useTranslation();

  const getFile = () => {
    let url = settings()?.investorTermsAndConditions?.replace('http://', 'https://');
    return url;
  };

  useEffect(() => {
    if (state) {
      setURLParam('currentStep', RegistrationURLSteps.termsCondition);
      if (userType === 'investor') {
        trackOpenPanelView(OpenPanelEvents.investorTermsViewed, {
          page_name: 'Investor terms',
          category: OpenPanelCategories.onboarding,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const onHandleSubmit = () => {
    setLoadingSubmit(true);
    investorRegService
      .submitTermsCondition().then(resp => {
        localStorage.setItem(LocalStorageKey.isTermsDone, "1");
        setURLParam('currentStep', RegistrationURLSteps.investorType);
        setLoadingSubmit(false);
        onClose();
      }).catch(err => { setLoadingSubmit(false); });
  };

  const onHandleDecline = () => {
    Logout();
    navigate(`${buildLocalizeRoute(AppRoutes.Login)}`);
  };

  return <DialogWrapper
    maxWidth="md"
    preventOutsideClick
    hideCloseBtn
    state={state}
    onClose={() => {
      onClose();
    }}
    title={t('termsConditionsInvestors')}
    content={
      <Box className='relative w-full'>
        <Box className='flex justify-end cursor-pointer items-center mb-2' >
          <DownloadIcon color="primary" className="!text-[16px]" />
          <a href={getFile()} target='_blank' className='!text-[14px]' rel="noreferrer">{t('download')}</a>
        </Box>
        <Box className="flex flex-col space-y-6">
          <Box>
            <InvestorTermsAndCondition />
          </Box>
        </Box >
      </Box >

    }
    actions={
      <Box className='flex justify-center items-center'>
        <FsButton variant="outline" disabled={loadingSubmit} onClick={() => {
          onHandleDecline();
        }}>{t('notRightNow')}</FsButton>
        <FsButton loading={loadingSubmit} className="!mx-3" onClick={() => {
          onHandleSubmit();
        }}>{t('iAgreeWithTerms')}</FsButton>
      </Box>
    }
  ></DialogWrapper >;
};